import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideOwnerForm from '../containers/CareGuideOwnerFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideOwnerEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideOwnerEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_owner_route_edit')} />
          <CareGuideOwnerForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideOwnerEditScreen;

Logger.log('silly', `CareGuideOwnerEditScreen loaded.`);
